import { add, isBefore, isFuture, isSameDay, isToday, parse } from "date-fns";

import type { TPickupTimeFrame } from "../types";

type TPickupTimeFrameDatesReturn = {
  hasDates?: boolean;
  minDate?: Date;
  maxDate?: Date;
  isDateAvailable?: (date: Date) => boolean;
};

const getPickupTimeFrameDates = (timeFrames: TPickupTimeFrame[], isWithTimes = true): TPickupTimeFrameDatesReturn => {
  const allFutureDateTimes = timeFrames.reduce<number[]>((acc, { date, cutoff, timeFrameFrom }) => {
    if (isFuture(date) && (!!timeFrameFrom?.length || !isWithTimes)) {
      acc.push(date.getTime());
      return acc;
    }
    const hasTimes = (timeFrameFrom || []).some(
      (timeFrom) => !isBefore(parse(timeFrom, "HH:mm", new Date()), add(new Date(), { minutes: cutoff || 0 }))
    );
    if (isToday(date) && (hasTimes || !isWithTimes)) {
      acc.push(date.getTime());
    }
    return acc;
  }, []);

  if (!allFutureDateTimes.length) {
    return { hasDates: false, minDate: undefined, maxDate: undefined, isDateAvailable: () => false };
  }

  const minDate = new Date(Math.min.apply(null, allFutureDateTimes));
  const maxDate = new Date(Math.max.apply(null, allFutureDateTimes));

  const isDateAvailable = (date: Date) =>
    allFutureDateTimes.some((timeFrameDateTime) => isSameDay(new Date(timeFrameDateTime), date));

  return { hasDates: true, minDate, maxDate, isDateAvailable };
};
export default getPickupTimeFrameDates;
